import React from 'react';
import { Row, Col } from 'react-flexbox-grid';
import { FormattedMessage } from 'react-intl';

import FormProvider from 'routes/Documents/containers/FormProvider';
import FormField from 'containers/FormField';

import GradeableField from '../containers/GradeableField';
import { predssSections } from '../Utils';
import { nowPartialDate } from 'neuro-utils';

const localeAccessor = (sect, grade) => (sect && (grade || grade === 0) ? `status.${sect}.${grade}` : null);

const PREDSSForm = props => {
  const isInDialog = props.isDialog;

  // Effect to set 'date' field as current date in partial form when creating a new PREDSS form
  React.useEffect(() => {
    if (!props.formValues.date && props.editing && Object.keys(props.initialValues).length === 0) {
      props.change('date', nowPartialDate());
    }
  }, []);

  return (
    <FormProvider {...props}>
      <FormField
        name="sections"
        component={GradeableField}
        localeAccessor={localeAccessor}
        sections={predssSections}
        isInDialog={isInDialog}
      />
      <Row center="xs" style={{ marginTop: '3rem', textAlign: 'center' }}>
        <Col xs={12} sm={9}>
          <i>Gisela Kobelt, Jenny Berg, Peter Lindgren, Bengt Jönsson. In: Eur J Health Econ 2006-7:S5-S13</i>
        </Col>
      </Row>
      <Row center="xs" style={{ marginTop: '3rem', textAlign: 'center' }}>
        <Col xs={12} sm={9}>
          <i>
            <FormattedMessage id="status.prEDSS.translated" />
          </i>
        </Col>
      </Row>
    </FormProvider>
  );
};

export default PREDSSForm;
